import Vue from 'vue';
import store from '../../store';

const success = (context, response, fromOnBoarding) => {
  if (fromOnBoarding) {
    context.airbnbAccount.loading = false;
    context.user.onboarding_step = 10;
    context.updateOnBoardingStep();
  } else {
    if (context.abAccount && context.abAccount.loading) {
      context.abAccount.loading = false;
    }
    if (context.users) {
      store.dispatch('updateIsSyncProgress', response.isSyncInProgress);
      context.users.isSyncInProgress = response.isSyncInProgress;
    }
    if (context.smallLoading) {
      context.smallLoading = false;
    }
    context.closeModal('.add-new-airbnb-account');
    context.closeModal('#import-airbnb-rentals');
    if (context.users.isSyncInProgress) {
      context.show_sync_in_process_modal();
    } else {
      toastr.success(context.$t('account.settings.new_rentals_import'))
    }
  }
};


const failed = (context, error, fromOnBoarding) => {
  if (fromOnBoarding) {
    context.airbnbAccount.loading = false;
  } else {
    if (context.abAccount && context.abAccount.loading) {
      context.abAccount.loading = false;
    }
    if (context.smallLoading) {
      context.smallLoading = false;
    }
  }
  context.showToasterError(error);
};


export default ((context, airbnbListings, airbnbAccount, fromOnBoarding = true) => {
  return Vue.$http.post('/import-airbnb-listings', { 
    airbnb_listings: airbnbListings, 
    airbnb_account_id: airbnbAccount.id 
  }).then((response) => {
    if (response && response.status === 200) {
      success(context, response.data, fromOnBoarding);
    } else {
      failed(context, response, fromOnBoarding);
    }
  }).catch(((error) => {
    failed(context, error, fromOnBoarding);
  }))
});



// WEBPACK FOOTER //
// ./src/app/services/rental/importAirbnbListingsToBeds24.js